import { Model, ModelAttributes, collection, model, modelConfig, reference } from "@mixitone/oom";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingOutreach from "./FundingOutreach";
import { setAccountId } from "./concerns/SetAccountId";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    contact_email: {
      type: "string",
    },
    contact_name: {
      type: "string",
    },
    contact_phone: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    created_by_account_user_id: {
      type: "string",
    },
    funder_type: {
      type: "enum",
      enumType: "" as Database["public"]["Enums"]["funder_type"],
    },
    funding_email_opted_out_club_wide_at: {
      type: "datetime",
    },
    is_deleted: {
      type: "boolean",
    },
    name: {
      type: "string",
    },
    note: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
    website: {
      type: "string",
    },
  },
  {
    outreach: collection(() => FundingOutreach as any, "funder_id"),
  },
  {
    club: reference(() => Club as any, "club_id"),
    created_by_account_user: reference(() => AccountUser as any, "created_by_account_user_id"),
  },
);

interface Funder extends ModelAttributes<typeof config> {}

@setAccountId
@model("funders", config)
class Funder extends Model<typeof config> {}

export default Funder;
